var map = {
	"./logo-alphabet.svg": 573,
	"./logo-amazon-2.svg": 574,
	"./logo-amazon.svg": 614,
	"./logo-azercell.svg": 615,
	"./logo-bank-of-america.svg": 616,
	"./logo-barclays.svg": 617,
	"./logo-bbc.svg": 618,
	"./logo-bloomberg.svg": 575,
	"./logo-bnp-paribas.svg": 619,
	"./logo-booking.svg": 620,
	"./logo-citibank.svg": 621,
	"./logo-cnbc.svg": 576,
	"./logo-cnbc2.svg": 622,
	"./logo-coca-cola-auto.svg": 572,
	"./logo-coca-cola-white.svg": 1640,
	"./logo-coca-cola.svg": 623,
	"./logo-deloitte.svg": 624,
	"./logo-experian.svg": 625,
	"./logo-facebook.svg": 626,
	"./logo-forbes.svg": 577,
	"./logo-g.svg": 1641,
	"./logo-goldman-sachs-new.svg": 627,
	"./logo-goldman-sachs.svg": 1492,
	"./logo-google-new.svg": 628,
	"./logo-google.svg": 629,
	"./logo-h.svg": 630,
	"./logo-henkel.svg": 631,
	"./logo-hsbc-new.svg": 632,
	"./logo-hsbc.svg": 1490,
	"./logo-ikea-new.svg": 633,
	"./logo-ikea.svg": 1642,
	"./logo-infineon.svg": 634,
	"./logo-instagram-icon.svg": 570,
	"./logo-instagram.svg": 635,
	"./logo-jp-morgan.svg": 636,
	"./logo-jti.svg": 637,
	"./logo-linkedin.svg": 638,
	"./logo-meta-new.svg": 569,
	"./logo-meta.svg": 1593,
	"./logo-morgan-stanley-new.svg": 639,
	"./logo-morgan-stanley.svg": 1491,
	"./logo-netflix.svg": 1488,
	"./logo-oracle.svg": 578,
	"./logo-paypal.svg": 640,
	"./logo-pwc-new.svg": 571,
	"./logo-pwc.svg": 1643,
	"./logo-spotify.svg": 1489,
	"./logo-tesla.svg": 641,
	"./logo-usa-today.svg": 579,
	"./logo-visa.svg": 642,
	"./logo-walmart.svg": 580,
	"./logo-wsj.svg": 581,
	"./logo-youtube.svg": 643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1131;